// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"2a0ab6f8","225":"7f92e55c","344":"b46cc879","372":"c8e6e25d","377":"3486500a","572":"70719a6a","573":"c8a5a9ff","738":"a0102271","841":"2aeee6ff","856":"60d0a668"}[chunkId] + ".chunk.js";
};